import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { loadManifests } from '../services/manifestsService'
import { loadMenus } from '../services/menusService'
import { IMfeManifest, IMfeMenu, IMfeState } from '../types'
import { getUser } from '../../auth'

export const initialState: IMfeState = {
  initialized: false,
  manifests: [],
  menus: [],
}

const initializeMfes = createAsyncThunk('mfe/initializeMfes', async () => {
  const manifests = await loadManifests()
  const menus = loadMenus(manifests, getUser().info)
  return { manifests, menus }
})

const mfeSlice = createSlice({
  name: 'mfe',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      initializeMfes.fulfilled,
      (
        state: IMfeState,
        action: PayloadAction<{ manifests: IMfeManifest[]; menus: IMfeMenu[] }>,
      ) => {
        state.initialized = true
        state.manifests = action.payload.manifests
        state.menus = action.payload.menus
      },
    )
  },
})

export { initializeMfes }
export default mfeSlice.reducer
